export enum LocationType {
  NotOperated = 'NotOperated',
  NotOperatedByLLA = 'NotOperatedByLLA',
  OperatedByLLA = 'OperatedByLLA'
}
